import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './index.css';
import App from './App';

/**
 * TanStack Query client configuration (Pattern 8.2 / NFR-RESIL-FE-02).
 *
 * - staleTime: 0   — data is always considered stale; refetch is controlled
 *                    exclusively by refetchInterval set per-query hook
 * - retry: 2       — retry failed requests twice before surfacing the error
 * - retryDelay: 1s — wait 1 s between automatic retries (handles HTTP 429)
 * - refetchOnWindowFocus: false — avoid spurious refetches on tab switch
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: 2,
      retryDelay: 1000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* DevTools panel — tree-shaken out of production builds */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
